import { EntFinancialIndicatorsFilter } from "../../../../../models/filters/financialIndicatorsFilter"; 
import { EntFinancialIndicators } from "../../../../../models/mechanization/financialIndicators"; 
import { ResponseDataGet } from "../../../../../models/responseDataGet"; 
import { agroApi } from "../../../../../redux/api/api"; 

export interface FinancialIndicatorsByYears {
  year: number;
  financialIndicators: EntFinancialIndicators[];
}
export interface EntYearsFilter {
  years: number[]
}
export const financesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinanceAnalyticalData: builder.query<ResponseDataGet<EntFinancialIndicators>, string>({
        query: (alias) => ({
          url: `/financial-indicators-register/analytical-data?governmentAlias=${alias}`,
          method: 'GET'
        })
      }),
  }),
  overrideExisting: false,
});

export const {
  useGetFinanceAnalyticalDataQuery,
} = financesApi;
